import type { BottomSheetProps } from 'components/molecules/BottomSheet';
import BottomSheet from 'components/molecules/BottomSheet';
import { SpinnerLoader } from 'components/molecules/Loaders';
import { useGetAllCustomerAddresses } from 'pages/queries/address.queries';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import AddressList from './addressList';

interface Props extends BottomSheetProps {
  isLoading?: boolean;
  disabled?: boolean;
  actionButtonProps?: {
    isLoading?: boolean;
  };
}

const StyledLoader = styled(SpinnerLoader)`
  z-index: 1;
  top: 35%;
`;

const StyledBottomSheet = styled(BottomSheet)`
  & .mb-6 {
    margin-bottom: 10px !important;
  }
`;

const AddressSheet: React.FC<Props> = ({ disabled, actionButtonProps, ...props }) => {
  const { data: addresses, isLoading } = useGetAllCustomerAddresses({ enabled: !disabled });
  const { t } = useTranslation();

  return (
    <StyledBottomSheet {...props} title={t('common.selectAddress')}>
      {isLoading && <StyledLoader />}
      <AddressList actionButtonProps={actionButtonProps} disabled={disabled} addresses={addresses ?? []} />
    </StyledBottomSheet>
  );
};

export default AddressSheet;
